import { render, staticRenderFns } from "./SaleOrderStatus.vue?vue&type=template&id=59e9a178&scoped=true"
import script from "./SaleOrderStatus.vue?vue&type=script&lang=js"
export * from "./SaleOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e9a178",
  null
  
)

export default component.exports